import * as React from 'react';

import {formEncodedApi} from 'nutshell-core/api';

import {Button} from 'shells/button/button';
import {Card} from 'shells/card/card';
import {Link} from 'shells/link/link';
import {Header} from 'shells/typography/header';
import {Subheader} from 'shells/typography/subheader';

import StagesEmptySvg from './assets/stages-empty.svg';

import styles from './sales-automation-open-leads-board-empty.module.css';

type Props = {
    onCreateStage: () => void;
};

export class SalesAutomationOpenLeadsBoardEmpty extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles['stages-empty']}>
                <Card hasBorder={true}>
                    <div className={styles.group}>
                        <div className={styles.left}>
                            <Header>Build your pipeline</Header>
                            <Subheader>
                                Create and configure the stages that you’ll use to organize your
                                leads.
                            </Subheader>
                            <Button
                                onClick={this.props.onCreateStage}
                                variant='primary'
                                size='xlarge'
                            >
                                Add stage
                            </Button>
                        </div>
                        <div className={styles.right}>
                            <div className={styles['stages-empty-svg']}>
                                <StagesEmptySvg />
                            </div>
                        </div>
                    </div>
                </Card>
                <Card hasBorder={true}>
                    <div className={styles.group}>
                        <div className={styles.left}>
                            <Header>Download a guide</Header>
                            <Subheader>
                                Get all 16 of our sales process templates, including cold emailing,
                                team selling, and enterprise sales.
                            </Subheader>
                            <Link
                                href='/dotcom/process-templates'
                                newTab={true}
                                onClick={() => {
                                    formEncodedApi.post('/my-account/save-user-setting.json', {
                                        setting: 'has_closed_sa_template_download',
                                        value: 1,
                                    });
                                    NutClientConfig.shouldShowSalesAutomationTemplateDownloadCTA =
                                        false;
                                }}
                                variant='primary'
                            >
                                View templates
                            </Link>
                        </div>
                        <div className={styles.right}>
                            <div>
                                <img
                                    src='/include/images/sales-automation/sales-process-templates.jpg'
                                    width='205px'
                                />
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }
}
